<template>
  <div>
    <navMenu />
    
    <hero :heroTitle="$t('javascriptGamesPage.title')" class="pb-0"/>

    <section class="jsk-block pt-0">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-8 offset-lg-2 col-md-12 text-center">
            <p>{{ $t("javascriptGamesPage.learnings") }}</p>
            <span class="badge badge-pill bg-yellow mr-2">{{ $t("coursesPage.moduleThreeAge") }}</span>
            <span class="badge badge-pill bg-yellow mr-2">{{ $t("coursesPage.moduleThreeLevel") }}</span>
            <span class="badge badge-pill bg-black mr-2">{{ $t("coursesPage.moduleThreePrice") }}</span> 
          </div>
        </div>
      </div>
    </section>

   <courseDetails 
    :scheduleText="$t('javascriptGamesPage.schedule')"
    :locationText="$t('javascriptGamesPage.location')"
    :priceText="$t('javascriptGamesPage.price')"
   />

    <cta :ctaText="$t('cta.javascriptGamesPageText')"/>

    <featured />

    <footerJSK />
  </div>
</template>

<script>
import navMenu from "../components/navMenu.vue";
import hero from "../components/hero.vue";
import courseDetails from "../components/courseDetails.vue";
import cta from "../components/cta.vue";
import featured from "../components/featured.vue";
import footerJSK from "../components/footer.vue";

export default {
  name: "ReadyGoPlay",
  components: {
    navMenu,
    hero,
    courseDetails,
    cta,
    featured,
    footerJSK
  },
  mounted () {
    window.scrollTo(0, 0)
  }
};
</script>

